module.exports = __webpack_public_path__ + "img/maky-9.28b8a892.png";